exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide-clear-btn .el-picker-panel__footer .el-picker-panel__link-btn:first-child {\n  display: none !important;\n}\n", ""]);

// exports
